import * as Yup from 'yup';
import { get } from 'lodash';

import history from 'browserHistory';
import { trims } from 'utils';
import { OperatingProcedures } from 'utils/enums';

Yup.addMethod(Yup.string, 'uniqueOrders', function (parent: string) {
  // @ts-ignore
  return this.test('uniqueOrders', parent, function (obj: string) {
    // @ts-ignore
    const { value } = this.from[1];
    const list = get(value, 'orders');

    const uniqValues = [] as any[];
    const doubles = [] as any[];

    list.forEach((doc: any) => {
      const val = trims(String(doc[parent]) || '');

      if (uniqValues.includes(val) && !doubles.includes(val)) {
        doubles.push(val);
      } else {
        uniqValues.push(val);
      }
    });

    if (!doubles.includes(trims(obj || ''))) return true;

    return this.createError({
      path: this.path,
      message: 'Вже є у списку',
    });
  });
});

const regDocValidationSchema = (statusId: number, operatingProcedure: string) => {
  const pathMode = history.location.pathname.split('/')[1];

  return Yup.object().shape({
    orders: (() => {
      let validation = Yup.array();

      if (pathMode === 'ordering' && operatingProcedure === OperatingProcedures.RulesOne) {
        validation = validation
          .of(
            Yup.object().shape({
              isDeleted: Yup.boolean(),
              isInputError: Yup.boolean(),
              number: Yup.string().when(['isDeleted', 'isInputError'], {
                is: (isDeleted: boolean, isInputError: boolean) => !isDeleted && !isInputError,
                then: Yup.string()
                  .nullable() // @ts-ignore
                  .uniqueOrders('number')
                  .required("Обов'язкове поле"),
              }),
              orderObject: Yup.string()
                .nullable()
                .when(['isDeleted', 'isInputError'], {
                  is: (isDeleted: boolean, isInputError: boolean) => !isDeleted && !isInputError,
                  then: Yup.string().required("Обов'язкове поле"),
                }),
              businessPartnerCode: Yup.string().nullable(),
              locationId: Yup.string().when(['isDeleted', 'isInputError'], {
                is: (isDeleted: boolean, isInputError: boolean) => !isDeleted && !isInputError,
                then: Yup.string().required("Обов'язкове поле").nullable(),
              }),
              orderHand: Yup.number().when(['isDeleted', 'isInputError'], {
                is: (isDeleted: boolean, isInputError: boolean) => !isDeleted && !isInputError,
                then: Yup.number().moreThan(0, "Обов'язкове поле").required("Обов'язкове поле").nullable(),
              }),
              isOrderChanged: Yup.boolean(),
            }),
          )
          .test({
            test: (data) => !!data && data.filter((d) => !d.isDeleted).filter((d) => !d.isInputError).length > 0,
          })
          .min(1, 'Заповніть поле')
          .required('Заповніть документи');

        return validation;
      }
      return validation;
    })(),
    isHighPriority: Yup.boolean(),
    сarrierType:
      pathMode === 'ordering'
        ? Yup.string()
            .nullable()
            .test('carrier-type-required', "Тип перевізника обов'язкове поле", function (value) {
              const orders = get(this.parent, 'orders');
              const hasFilledOrders =
                Array.isArray(orders) &&
                orders.some(
                  (order: any) => !order?.isDeleted && !order?.isInputError && trims(String(order?.number || '')),
                );

              const isRulesOneRequired = operatingProcedure === OperatingProcedures.RulesOne && statusId === 2;
              const isRulesTwoThreeRequired =
                (operatingProcedure === OperatingProcedures.RulesTwo ||
                  operatingProcedure === OperatingProcedures.RulesThree) &&
                (statusId === 1 || statusId === 2) &&
                hasFilledOrders;

              if (!isRulesOneRequired && !isRulesTwoThreeRequired) return true;

              return value !== null && value !== undefined && trims(String(value)) !== '';
            })
        : Yup.string().nullable(),
  });
};

export default regDocValidationSchema;
